import type { StoreUser } from '../../../../types/services/auth';
import { getDigitsOnly } from './storeDetailsInviteUserUtils';

export type StoreDetailsUserLoginMethod = 'phone' | 'email' | 'pin';

export const STORE_DETAILS_USER_LOGIN_LABELS: Record<StoreDetailsUserLoginMethod, string> = {
    phone: 'Phone OTP',
    email: 'Email OTP',
    pin: 'Pin',
};

export const getStoreDetailsUserEmail = (user: StoreUser): string =>
    String(user.contact_email || user.email || user.email_address || '').trim();

export const resolveStoreDetailsUserLoginMethod = (user: StoreUser): StoreDetailsUserLoginMethod => {
    const explicitLoginField = String(user.login_field || '').toLowerCase();
    if (explicitLoginField === 'email' || explicitLoginField === 'phone') {
        return explicitLoginField;
    }

    const hasPhone = Boolean(getDigitsOnly(user.phone_number));
    const hasEmail = Boolean(getStoreDetailsUserEmail(user));

    if (user.has_pin && !hasPhone && !hasEmail) {
        return 'pin';
    }

    if (hasEmail && !hasPhone) {
        return 'email';
    }

    return 'phone';
};
